<template>
  <div
      class="progress-container"
      :style="{
      backgroundColor: backgroundColor,
      height: height,
      borderRadius: borderRadius
    }"
  >
    <div
        class="progress-bar"
        :style="{
        width: currentProgress + '%',
        backgroundColor: progressColor,
        height: '100%'
      }"
    ></div>
  </div>
</template>

<script setup>
import { ref, watch, onBeforeUnmount } from 'vue'

// Definition der Props
const props = defineProps({
  /** Ziel-Fortschritt in Prozent (z.B. 10 für 10%) */
  progress: {
    type: Number,
    default: 0
  },
  /** Verzögerung in Millisekunden zwischen den Schritten */
  stepDelay: {
    type: Number,
    default: 50
  },
  /** Schrittweite (in Prozent), um die der Balken pro Intervallwert erhöht wird */
  stepSize: {
    type: Number,
    default: 1
  },
  /** Hintergrundfarbe des Fortschrittsbalken-Hintergrunds */
  backgroundColor: {
    type: String,
    default: '#eee'
  },
  /** Farbe des Fortschrittsbalkens */
  progressColor: {
    type: String,
    default: '#4caf50'
  },
  /** Höhe des Fortschrittsbalkens */
  height: {
    type: String,
    default: '20px'
  },
  /** Border-Radius für abgerundete Ecken */
  borderRadius: {
    type: String,
    default: '4px'
  }
})

// Interner Zustand, der den aktuell angezeigten Fortschritt speichert
const currentProgress = ref(props.progress)

// Timer-ID für die Intervallsteuerung
let timer = null

/**
 * Aktualisiert currentProgress in kleinen Schritten, bis der Zielwert erreicht ist.
 */
const updateProgress = (target) => {
  // Falls bereits ein Timer läuft, diesen löschen
  if (timer) {
    clearInterval(timer)
  }
  timer = setInterval(() => {
    if (currentProgress.value < target) {
      currentProgress.value = Math.min(currentProgress.value + props.stepSize, target)
    } else if (currentProgress.value > target) {
      // Falls der Wert auch mal sinken soll (in der Regel passiert das nicht)
      currentProgress.value = Math.max(currentProgress.value - props.stepSize, target)
    }
    if (currentProgress.value === target) {
      clearInterval(timer)
      timer = null
    }
  }, props.stepDelay)
}

// Beobachtung der progress-Prop: Bei Änderung wird der Fortschritt animiert.
watch(
    () => props.progress,
    (newVal) => {
      updateProgress(newVal)
    }
)

// Timer beim Zerstören der Komponente bereinigen
onBeforeUnmount(() => {
  if (timer) {
    clearInterval(timer)
  }
})
</script>

<style scoped>
.progress-container {
  width: 100%;
  overflow: hidden;
}

.progress-bar {
  /* Keine CSS-Animation, da die Animation via JavaScript erfolgt */
}
</style>
